import * as React from "react";
import PropTypes from 'prop-types';

const SvgArrowLeft = props => {
  if (props.id !== "_svgarrowleft") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><path d="M167.052 224.1a9.97 9.97 0 01-7.071-2.929l-94.1-94.1c-3.905-3.905-3.905-10.237 0-14.142l94.1-94.101c3.906-3.905 10.236-3.906 14.143 0 3.905 3.905 3.905 10.237 0 14.142L87.094 120l87.029 87.028c3.905 3.905 3.905 10.237 0 14.143a9.972 9.972 0 01-7.071 2.929z" /></svg>;
};

SvgArrowLeft.displayName = "_svgarrowleft";
SvgArrowLeft.propTypes = {
  id: PropTypes.string
};
SvgArrowLeft.defaultProps = {
  id: ''
};
export default SvgArrowLeft;